import { debounce } from 'lodash'
import { refreshAuthToken } from './actions'
import { UnauthorizedError } from 'api'
import { isAuthenticatedSelector } from './selectors'
const { location } = window

/**
 * Periodically refreshes the auth token
 */

export default store => {
  const debouncedRefreshAuthToken = debounce(() => store.dispatch(refreshAuthToken()), 2000)
  // Tracks pathname only (not query/search), so a same-page filter or tab
  // click — a query-string-only location change, e.g. /events?type=guest —
  // doesn't count as a "new page" below.
  let lastPathname = null

  return next => action => {
    if (action.error && action.error instanceof UnauthorizedError) {
      location.href = '/login'
    } else if (action.type === '@@router/LOCATION_CHANGE') {
      const pathname = action.payload && action.payload.pathname
      const pathnameChanged = pathname !== lastPathname
      lastPathname = pathname

      // Refreshing on every location change meant a same-page filter/tab
      // click refreshed the token too — and refreshAuthToken() hard-reloads
      // the page if that particular refresh comes back unauthorized, so a
      // filter click could trigger a full-page reload unrelated to any real
      // navigation. Only an actual move to a new page needs this.
      if (pathnameChanged && isAuthenticatedSelector(store?.getState?.())) {
        debouncedRefreshAuthToken()
      }
    }

    return next(action)
  }
}
